export default __webpack_public_path__ + "static/media/Damaso_No8Closed.503d2865.jpg";